import {ISearchFilterSlot} from "../../types/ISearchFilters";
import {SearchFilterTypes} from "../../types/SearchFilterTypes";

export const constructionEndDate: ISearchFilterSlot<"construction_end_date", number[]> = {
    id: "construction_end_date",
    label: "Termin oddania",
    filters: [
        {
            id: "construction_end_date",
            type: SearchFilterTypes.RADIO,
            filterOptions: [
                {id: "0", value: 0, label: "Gotowe do odbioru"},
                {id: "3", value: 3, label: "Do 3 miesięcy"},
                {id: "6", value: 6, label: "Do 6 miesięcy"},
                {id: "12", value: 12, label: "Do roku"},
                {id: "36", value: 36, label: "Do 3 lat"}
            ]
        }
    ]
};
import {ISearchFilterSlot} from "../../types/ISearchFilters";
import {SearchFilterTypes} from "../../types/SearchFilterTypes";

export const constructionEndDate: ISearchFilterSlot<"construction_end_date", number[]> = {
    id: "construction_end_date",
    label: "Termin oddania",
    filters: [
        {
            id: "construction_end_date",
            type: SearchFilterTypes.RADIO,
            filterOptions: [
                {id: "0", value: 0, label: "Gotowe do odbioru"},
                {id: "3", value: 3, label: "Do 3 miesięcy"},
                {id: "6", value: 6, label: "Do 6 miesięcy"},
                {id: "12", value: 12, label: "Do roku"},
                {id: "36", value: 36, label: "Do 3 lat"}
            ]
        }
    ]
};
